import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import {autobind} from 'core-decorators';
import {injectIntl, intlShape, FormattedMessage} from 'react-intl';
import * as FormatUtils from 'utils/formatUtils';
import {getNextPayment, getPurchaseMergedStatus, getSumLatePaymentsAmount} from './helpers';
import * as purchaseConstants from './constants';
import PurchaseInfo from './PurchaseInfo';
import styles from './purchaseDetails.scss';
import Dialog from 'components/common/material/Dialog';

@injectIntl
@CSSModules(styles, {allowMultiple: true, errorWhenNotFound: false})
class PurchaseDetails extends React.Component {
  static propTypes = {
    intl: intlShape,
    purchase: PropTypes.object.isRequired,
    togglePayNow: PropTypes.func.isRequired,
    togglePaymentsSchedule: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      promotionalDialogVisible: false
    };
  }

  @autobind
  togglePromotionalDialog() {
    this.setState({promotionalDialogVisible: !this.state.promotionalDialogVisible});
  }

  render() {

    const {purchase} = this.props;
    const {isZeroAprPromoted} = purchase;
    const verticalClassName = classNames(styles.vertical, styles['vertical_' + purchase.vertical]);
    const mergedStatus = getPurchaseMergedStatus(purchase);

    let paymentsInfoComponent = null;
    switch (mergedStatus) {
      case purchaseConstants.PURCHASE_STATUS_MERGED_UNKNOWN:
      case purchaseConstants.PURCHASE_STATUS_MERGED_ON_SCHEDULE:
        paymentsInfoComponent = this.renderPaymentsInfoWithNextPayment();
        break;

      case purchaseConstants.PURCHASE_STATUS_MERGED_LATE:
        paymentsInfoComponent = this.renderPaymentsInfoLate();
        break;

      default:
        paymentsInfoComponent = this.renderPaymentsInfoBigIcon();
    }

    return (
      <div data-at="purchaseSummaryContainer" styleName="purchaseDetails">
        <div styleName="purchaseDetailsInner">
          <div styleName="purchaseInfo">
            <div className={verticalClassName} />
            <PurchaseInfo purchase={purchase} />
          </div>
          {paymentsInfoComponent}
        </div>
        { isZeroAprPromoted && this.renderPromotionalText() }
        { this.state.promotionalDialogVisible && this.renderPromotionalDialog() }
      </div>
    );
  }

  renderPaymentsInfoWithNextPayment() {
    const {purchase, togglePaymentsSchedule, intl:{formatMessage}} = this.props;
    const nextPayment = getNextPayment(purchase.allPaymentsIncludingDownPayment);

    if (!nextPayment) {
      return null;
    }

    return (
      <div styleName="paymentsInfo">
        <div styleName="group">
          <div styleName="amountDescription" data-at="amountDescription">{formatMessage({id: 'purchase.paymentsInfo.amountDescription.nextPayment'})}</div>
          <div styleName="amountDate" data-at="amountDate">{FormatUtils.transformDate(nextPayment.dueDate)}</div>
        </div>
        <div styleName="group">
          <div styleName="amount" data-at="amount">{FormatUtils.addPriceSymbol(nextPayment.amount)}</div>
          <div styleName="viewPaymentsWrap"><a styleName="viewPayments" data-at="viewPaymentsButton" onClick={togglePaymentsSchedule}>{formatMessage({id: 'purchase.action.label.viewPayments'})}</a></div>
        </div>
      </div>
    );
  }

  renderPaymentsInfoLate() {
    const {purchase, togglePaymentsSchedule, intl:{formatMessage}} = this.props;
    const lateAmount = getSumLatePaymentsAmount(purchase.allPaymentsIncludingDownPayment);
    const mergedStatus = getPurchaseMergedStatus(purchase);

    return (
      <div styleName="paymentsInfo">
        <div styleName="group">
          <div styleName="amountDescription" data-at="amountDescription">{formatMessage({id: 'purchase.paymentsInfo.amountDescription.late'})}</div>
          <div styleName="statusSmall" data-at="status">{formatMessage({id: purchaseConstants.mergedStatusToText[mergedStatus]})}</div>
        </div>
        <div styleName="group">
          <div styleName="amount" data-at="amount">{FormatUtils.addPriceSymbol(lateAmount)}</div>
          <div styleName="viewPaymentsWrap"><a styleName="viewPayments" data-at="viewPaymentsButton" onClick={togglePaymentsSchedule}>{formatMessage({id: 'purchase.action.label.viewPayments'})}</a></div>
        </div>
      </div>
    );
  }

  renderPaymentsInfoBigIcon() {
    const {purchase, togglePaymentsSchedule, intl:{formatMessage}} = this.props;
    const mergedStatus = getPurchaseMergedStatus(purchase);
    const statusClassName = classNames('statusIconLarge', mergedStatus === purchaseConstants.PURCHASE_STATUS_MERGED_PAID ? 'paid' : '');

    return (
      <div styleName="paymentsInfo">
        <div styleName="group">
          <div styleName={statusClassName} />
        </div>
        <div styleName="group">
          <div styleName="statusTextLarge" data-at="status">{formatMessage({id: purchaseConstants.mergedStatusToText[mergedStatus]})}</div>
          <div styleName="viewPaymentsWrap"><a styleName="viewPayments" data-at="viewPaymentsButton" onClick={togglePaymentsSchedule}>{formatMessage({id: 'purchase.action.label.viewPayments'})}</a></div>
        </div>
      </div>
    );
  }

  renderPromotionalText() {

    const {purchase} = this.props;

    const dateTime = new Date(purchase.dateTime);
    const nextMonthDateTime = new Date(dateTime.setMonth(dateTime.getMonth() + 1));
    const values = {
      date: FormatUtils.transformDate(nextMonthDateTime),
      seeImportantDetails: <button onClick={this.togglePromotionalDialog}><FormattedMessage id="purchase.details.promotional.importantDetails"/></button>
    };

    return (
      <div styleName="promotional">
        <FormattedMessage id="purchase.details.promotional.text" values={values}/>
      </div>
    );
  }

  renderPromotionalDialog() {
    const {purchase, intl:{formatMessage}} = this.props;
    const {zeroAprPromotionExpirationDate} = purchase;
    const values = {
      date: FormatUtils.transformDate(zeroAprPromotionExpirationDate)
    };

    const actions = [
      {onClick: this.togglePromotionalDialog, primary: true, label: formatMessage({id: 'common.ok'})},
    ];

    return (
      <Dialog actions={actions} active={true}>
        <FormattedMessage id="purchase.details.promotional.details" values={values}/>
      </Dialog>
    );
  }

}

export default PurchaseDetails;



// WEBPACK FOOTER //
// ./src/purchases/PurchaseDetails.js